
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, addDoc } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB66Ia_8aI2lzjb3FhC3tzcCeLEI9fPyNg",
  authDomain: "heradexiawaitl.firebaseapp.com",
  projectId: "heradexiawaitl",
  storageBucket: "heradexiawaitl.firebasestorage.app",
  messagingSenderId: "475265275532",
  appId: "1:475265275532:web:380ca7c8c39efad4a48da9",
  measurementId: "G-P7CBTK5401"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
export { db, collection, addDoc };